import { render } from "./create-account.vue?vue&type=template&id=7f94d45f&ts=true"
import script from "./create-account.vue?vue&type=script&lang=ts"
export * from "./create-account.vue?vue&type=script&lang=ts"

import "./create-account.vue?vue&type=style&index=0&id=7f94d45f&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__